// src/components/JobList.tsx
import React, { useEffect, useState } from 'react';
import { useAuth } from '../AuthContext';
import DownloadButton from './DownloadButton';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { Job } from './types'; // adjust path as needed
import { BASE_URI, prettyPrintDate } from '../Config';


interface JobsProps {
    userId: string;
    jobs: Job[];
    setJobs: (jobs: Job[]) => void;
}

const JobList: React.FC<JobsProps> = ({ jobs, setJobs, userId}) => {
    // const [jobs, setJobs] = useState<Job[]>([]);
    const [jobsPageSubset, setJobsPageSubset] = useState<Job[]>([]);
    // const [jobsPage, setJobsPage] = useState<number>(0);
    const navigate = useNavigate();
    const location = useLocation();
    const page_size = 10;
    const { userToken } = useAuth();

    const getPageFromURL = (): number => {
        const params = new URLSearchParams(location.search);
        const page = params.get('page');
        return page ? parseInt(page) - 1 : 0;  // Subtract 1 to make it 0-based index for your logic
    }

    // Mock API call
    const fetchJobs = async () => {
        // await new Promise(resolve => setTimeout(resolve, 1000)); // Simulate network delay
        try {
            const response = await fetch(`${BASE_URI}/jobs/list/${userId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${userToken}`
                }
            });

            const data = await response.json();

            if (data.jobs) {
                console.log("Retrieved jobs successful!");
                console.log(data);
                setJobs(data.jobs);
                // Redirect or perform other actions after successful signup
            } else {
                console.log("Retrieved jobs failed!");
            }
        } catch (error) {
            console.error("There was an error during retrieving jobs:", error);
        }
        
    };

    const [jobsPage, setJobsPage] = useState<number>(getPageFromURL());
    useEffect(() => {
        if (jobsPage >= 0) {
            navigate(`${location.pathname}?page=${jobsPage + 1}`, { replace: true });
        }
    }, [jobsPage, navigate, location.pathname]);

    useEffect(() => {
        fetchJobs();
    }, [userToken, ]);

    useEffect(() => {
        // setJobsPageSubset(jobs.sort((a, b) => (new Date(a.created_at).getTime() - new Date(b.created_at).getTime())*-1 ).slice(jobsPage * page_size, (jobsPage+1) * page_size))
        setJobsPageSubset(jobs.sort().reverse().slice(jobsPage * page_size, (jobsPage+1) * page_size))
    }, [jobs, jobsPage]);

    useEffect(() => {
        const intervalId = setInterval(fetchJobs, 10000);
        // Clear the interval when the component is unmounted
        return () => clearInterval(intervalId);
    }, [])

    if (jobs.length == 0){
        return <div></div>;
    }

    return (
        <div>
        <h3 className='jobs'>Submitted Jobs</h3>
        <div className="pagination jobs">
            <span className="current_page">Page {jobsPage+1} of {Math.floor(jobs.length / page_size)+1}</span>
            {jobsPage !== 0 && <span className='previous_page' onClick={() => setJobsPage(jobsPage-1)}>Previous</span>}
            {(jobsPage+1)*page_size < jobs.length && <span className='next_page' onClick={() => setJobsPage(jobsPage+1)}>Next</span>}
        </div>
        <table>
            <thead>
                <tr>
                    <th>Date</th>
                    <th>Input file</th>
                    <th>Antigen</th>
                    <th>MHC</th>
                    <th>Status</th>
                    <th>Results</th>
                    <th>Download</th>
                </tr>
            </thead>
            <tbody>
                {jobsPageSubset.map(job => (
                    <tr key={job.id}>
                        <td>{prettyPrintDate(job.created_at)}</td>
                        <td><DownloadButton text={job.source_file_name} filename={"input_"+job.source_file_name} url_str={`jobs/${job.id}/download/input`}></DownloadButton></td>
                        <td>{job.target_antigen && job.target_antigen}</td>
                        <td>{job.target_mhc && job.target_mhc.replace("HLA-","")}</td>
                        <td>{job.job_status}</td>
                        <td><Link to={`/jobs/${job.id}`}>Link</Link></td>
                        <td>{(job.job_status === "Succeeded") && <DownloadButton text="Link" filename={"output_"+job.source_file_name} url_str={`jobs/${job.id}/download/output`}></DownloadButton>}</td>
                    </tr>
                ))}
            </tbody>
        </table>
        </div>
    );
}

export default JobList;
